import { Component, Host, h, Element } from "@stencil/core";

import { setPropsIfNull } from "../../utils/utils";

/**
 * @slot - Slot for label
 */
@Component({
  tag: "stzh-scrollup",
  styleUrl: "stzh-scrollup.scss",
  shadow: true,
})
export class StzhScrollup {
  @Element() element: HTMLStzhScrollupElement;

  private handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  private handleSlotchange = () => {
    const host = (this.element.getRootNode() as ShadowRoot)?.host || this.element;
    const links = host.querySelectorAll("stzh-link, stzh-button");

    links.forEach(link => {
      link.addEventListener("click", this.handleLinkClick);

      setPropsIfNull(link, {
        icon: "arrow-up",
      } as HTMLStzhLinkElement | HTMLStzhButtonElement);
    });
  };

  render() {
    const classes = {
      "stzh-scrollup": true,
    };

    return (
      <Host>
        <div class={classes}>
          <slot onSlotchange={this.handleSlotchange}></slot>
        </div>
      </Host>
    );
  }
}
